import { render, staticRenderFns } from "./PfLoanTransactionWizard.vue?vue&type=template&id=5bbdedb6"
import script from "./PfLoanTransactionWizard.vue?vue&type=script&lang=js"
export * from "./PfLoanTransactionWizard.vue?vue&type=script&lang=js"
import style0 from "./PfLoanTransactionWizard.vue?vue&type=style&index=0&id=5bbdedb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports